import React from 'react';
import { View, Text, type ViewProps } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { cn } from '@/utils/cn';

export interface ErrorMessageProps extends ViewProps {
  message: string;
  className?: string;
  textClassName?: string;
  showIcon?: boolean;
}

export function ErrorMessage({
  message,
  className,
  textClassName,
  showIcon = true,
  ...props
}: ErrorMessageProps) {
  if (!message) return null;

  return (
    <View className={cn('mt-1 flex-row items-center gap-2', className)} {...props}>
      {showIcon && <Ionicons name="alert-circle" size={16} className="text-error-500" />}
      <Text className={cn(' text-xs text-error-600', textClassName)}>
        {message}
      </Text>
    </View>
  );
}
